<template>
  <Grid gtc="2fr 1fr" gap="var(--r-space-xxl)" class="q-pt-md email-modal">
    <div class="left">
      <div class="text-button-big text-secondary-1">Message</div>
      <div class="line bg-white-5 q-mt-md" style="height: 1px; width: 100%"></div>

      <div class="text-subtitle-1 text-secondary-1 q-py-sm" v-html="email.body"></div>

      <div class="line bg-white-5 q-mt-sm" style="height: 1px; width: 100%"></div>

      <div class="text-body-3 text-secondary-1 q-pt-sm">Message reference: {{ email.id }}</div>
    </div>

    <Grid gap="40px" align-content="start" class="right">
      <div v-if="email.has_attachments" class="attachments">
        <div class="text-button-big text-secondary-1">Attachments</div>
        <div class="line bg-white-5 q-mt-md" style="height: 1px; width: 100%"></div>
        <Grid
          v-for="attachment of email.attachments"
          :key="attachment.id"
          gaf="column"
          align-items="center"
          justify-content="start"
          gap="var(--r-space-sm)"
          class="attachment q-pt-sm cursor-pointer"
          @click.native="download(attachment.id)"
        >
          <component :is="getFileType(attachment.url) + 'Icon'" />
          <div class="text-body-1 text-secondary-5">{{ attachment.name }}</div>
        </Grid>
      </div>

      <div class="metadata">
        <div class="text-button-big text-secondary-1">Metadata</div>
        <div class="line bg-white-5 q-mt-md" style="height: 1px; width: 100%"></div>

        <Grid gap="var(--twelve-px)" class="metadata-info pt-twelve">
          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Subject:</div>
            <div class="text-body-3 text-secondary-1">{{ email.subject }}</div>
          </Grid>

          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Message type:</div>
            <div class="text-body-3 text-secondary-1">Email</div>
          </Grid>

          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Sent:</div>
            <div class="text-body-3 text-secondary-1">{{ formatDateTimeForLocale(email.created_at) }}</div>
          </Grid>

          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Recipient address:</div>
            <a :href="`mailto:${email.to}`" class="text-body-1 text-link-blue">{{ email.to }}</a>
          </Grid>

          <Grid v-if="email.created_by" gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Author:</div>
            <div class="text-body-3 text-secondary-1">{{ email.created_by.name }}</div>
          </Grid>

          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Sender address:</div>
            <a :href="`mailto:${email.from}`" class="text-body-1 text-link-blue">{{ email.from }}</a>
          </Grid>

          <Grid gap="var(--r-space-xs)">
            <div class="text-body-1 text-secondary-1">Reply-to address:</div>
            <a :href="`mailto:${email.from}`" class="text-body-1 text-link-blue">{{ email.from }}</a>
          </Grid>
        </Grid>
      </div>
    </Grid>
  </Grid>
</template>

<script>
export default {
  components: {
    pdfIcon: () => import('@/ui/icons/PdfIcon'),
    xlsxIcon: () => import('@/ui/icons/Xlsx')
  },

  props: {
    email: {
      type: Object,
      required: true
    }
  },

  methods: {
    download(attachmentId) {
      this.$store.dispatch('downloadMedia', attachmentId, { root: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.email-modal {
  --twelve-px: calc(var(--r-space-sm) + var(--r-space-xs));

  .pt-twelve {
    padding-top: var(--twelve-px);
  }
}
</style>
